import { render, staticRenderFns } from "./AffirmBooks.vue?vue&type=template&id=d9733a34&"
import script from "./AffirmBooks.vue?vue&type=script&lang=js&"
export * from "./AffirmBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports